<template>
  <div class="hd">
    <img class="icon-tips" :src="bgImg[0]" />成员<span>{{ member }}</span
    >人，已上传<span>{{ curCount }}</span
    >张，还可以上传<span>{{ total - curCount }}</span
    >张作品
  </div>
</template>

<script>
export default {
  props: {
    curCount: {
      type: Number,
      default: 0,
    },
    member: {
      type: Number,
      default: 1,
    },
    total: {
      type: Number,
      default: 200,
    },
  },
  data() {
    return {
      bgImg: [require("@/static/images/group/i-1.png")],
      // member: 16,
    };
  },
};
</script>

<style lang="scss" scoped>
.hd {
  background: #fff8f6;
  width: 94%;
  margin: 0 auto;
  height: 64px;
  line-height: 64px;
  color: #f77e5e;
  text-align: center;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  img {
    vertical-align: middle;
    width: 30px;
    margin: -7px 8px 0 0;
  }
  span {
    font-weight: bold;
    margin: 0 5px;
  }
}
</style>
